"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GENESYS_WIDGET_FRAGMENT = exports.ChatsLoaderQuery = exports.CUSTOMER_FRAGMENT = exports.CHATBOT_FRAGMENT = void 0;
var _fetching = require("@ori/fetching");
const CHATBOT_FRAGMENT = exports.CHATBOT_FRAGMENT = (0, _fetching.gql)`
  fragment ChatbotFragment on Chat {
    chatBot(pageUrl: $pageUrl, isAuthenticated: $isAuthenticated) @include(if: $includeChatbot) {
      configuration {
        contactSupportUrl
        directLineChannelSecret
        isChatHandover
        isTestModeActive
        messageHistoryLimit
        mode
      }
    }
  }
`;
const GENESYS_WIDGET_FRAGMENT = exports.GENESYS_WIDGET_FRAGMENT = (0, _fetching.gql)`
  fragment GenesysWidgetFragment on Chat {
    genesys(pageUrl: $pageUrl, isAuthenticated: $isAuthenticated) @include(if: $includeGenesys) {
      configuration {
        buttonLabel
        dataUrl
        deploymentId
        organizationId
        pluginsPath
        queue
        scriptUrl
      }
      isMobileWidgetEnabled
      isPredictiveFeatureEnabled
    }
  }
`;
const CUSTOMER_FRAGMENT = exports.CUSTOMER_FRAGMENT = (0, _fetching.gql)`
  fragment CustomerFragment on Query {
    customer @include(if: $isAuthenticated) {
      firstName
      lastName
      emails {
        emailAddress
        isPending
      }
      title
      consultantNumber
      customerId
      phones {
        telephoneNumber
        isPrimary
        isVerified
      }
      preferredLanguage
    }
  }
`;
const ChatsLoaderQuery = exports.ChatsLoaderQuery = (0, _fetching.gql)`
  ${CUSTOMER_FRAGMENT}
  ${GENESYS_WIDGET_FRAGMENT}
  ${CHATBOT_FRAGMENT}

  query GetConfigurations(
    $includeChatbot: Boolean!
    $includeGenesys: Boolean!
    $isAuthenticated: Boolean!
    $pageUrl: String!
  ) {
    chat {
      ...ChatbotFragment
      ...GenesysWidgetFragment
    }
    # Customer fragment is needed for both chats.
    ...CustomerFragment
  }
`;
